export default {
  CLIENT_UPLOAD_ASSET: '@WS/CLIENT_UPLOAD_ASSET',
  CLIENT_UPLOAD_ASSETS: '@WS/CLIENT_UPLOAD_ASSETS',
  CLIENT_UPLOAD_EXTERNAL_ASSETS: '@WS/CLIENT_UPLOAD_EXTERNAL_ASSETS',
  CREATE_MEDIA_GALLERY_ASSETS: '@WS/CREATE_MEDIA_GALLERY_ASSETS',
  CREATE_MEDIA_GALLERY_ASSETS_FROM_EXTERNAL_SOURCES:
    '@WS/CREATE_MEDIA_GALLERY_ASSETS_FROM_EXTERNAL_SOURCES',
  FILE_SIZE_LIMIT_REACHED: '@WS/FILE_SIZE_LIMIT_REACHED',
};
